import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-container.css.lit';

/**
 * The SeContainer component
 * @element se-container
 * @slot - default
 */
@customElement('se-container')
export class SeContainer extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  /**
   * The vertical space from the component above it (using Utopia fluid space variables defined in outline.theme.css, ie. space-3xl)
   **/
  @property({
    type: String,
    reflect: true,
    attribute: 'top-margin',
  })
  topMargin: string;

  @property({
    type: Boolean,
    reflect: true,
    attribute: 'justify-end',
  })
  justifyEnd = false;

  @property({
    type: String,
    reflect: true,
    attribute: 'variant',
  })
  variant: string;

  render(): TemplateResult {
    return html` ${this.variant === 'narrow' ||
      this.topMargin ||
      this.justifyEnd
        ? html`
            <style>
              :host {
                ${this.variant === 'narrow'
                ? html`--container-max-content-width: 900px !important;`
                : ''};
                ${this.topMargin
                ? html` margin-top: var(--${this.topMargin}); `
                : ''};
                ${this.justifyEnd ? html` justify-content: flex-end; ` : ''};
              }
            </style>
          `
        : ''}
      <slot></slot>`;
  }
}
